import { useRouter } from 'next/router';
import { useQuery } from 'react-query';
import { useAccount } from '~/features/club';
import { Pages, PagesWithDetail, Redirect } from '~/lib/data-contract';
import { fetchPage } from '~/lib/fetchPage';
import { useLogging } from '~/shared/hooks';
import { minutes, useFranchise } from '~/shared/utils';

export const usePage = <T = Pages>(): T => {
    const { asPath, locale } = useRouter();
    const { authHeaders: headers } = useAccount();
    const { queryKey, key } = useFranchise();
    const { customException } = useLogging();

    // On SSR the locale is included in the path, but on client side it is not
    // So we need to remove it from the path if present
    const path =
        decodeURIComponent(asPath.split(/[?#]/)[0]).replace(new RegExp(`^/${locale}`), '') || '/';

    const pageQueryKey = ['page', { queryKey, path }];
    const url = `${locale}${path}`;

    const { data: page = {} } = useQuery<PagesWithDetail | Redirect, Error>(
        pageQueryKey,
        () => fetchPage(`${locale}${path}`, key, {}, headers),
        {
            retry: false,
            staleTime: minutes(10),
            cacheTime: minutes(1),
            refetchOnWindowFocus: true,
            keepPreviousData: true,
            onError: () => {
                customException(`Client page request failed! url: ${url}`);
            },
        }
    );

    return (page as unknown) as T;
};
